<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:搜索结果
-->
<template>
  <!-- :style="{ height: showCloseBtn ? '98%' : '0' }" -->
  <div class="searchPerson">
    <div class="openBtn" @click="clickClose"></div>
    <div
      class="search_person"
      :style="{
        height: showOpenBtn ? '98%' : '37%',
        minHeight: showCloseBtn ? '300px' : '0',
      }"
    >
      <div class="searchPersonContent">
        <div class="header">
          <div class="header-left" @click="refreshTable">
            <!-- <el-button>全部下载</el-button>
            <el-button>全部加入轨迹</el-button> -->
            <span style="margin: 0px 0px">刷新</span>
            <i
              class="iconfont icon-shuaxin"
              style="margin-left: 12px; cursor: pointer"
            ></i>
          </div>
          <div class="header-right">
            <!-- <span>类型：</span>
            <el-select v-model="tableParams.lx" placeholder="告警类型">
              <el-option
                v-for="(item, index) in searchList"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <!-- <span>来源：</span>
            <el-select v-model="tableParams.ly" placeholder="告警类型">
              <el-option label="在线视频" :value="1"></el-option>
              <el-option label="离线视频" :value="2"></el-option>
            </el-select> -->

            <i class="iconfont icon-caidan"></i>
            <span class="activeColor" @click="personSlot">轨迹列表</span>
            <div
              class="slot-list"
              v-show="showTrackList"
              :style="{ height: showOpenBtn ? '330px' : '165px' }"
            >
              <div class="slot-list-btn">
                <h-button
                  size="small"
                  :disabled="slotDisabled"
                  @click="playLine"
                >
                  播放</h-button
                >
                <!-- <h-button size="small"> 导出</h-button> -->
                <h-button size="small" @click="clearPlayLine"> 清空</h-button>
                <!-- <h-button size="small" @click="personAddSlot">
                  归到档案</h-button
                > -->
              </div>
              <div
                class="slot-list-item"
                v-for="item in slotList"
                :key="item.id"
              >
                <div class="slot-name" @click="handleTask(item)">
                  {{ item.sourceName }}
                </div>
                <div class="slot-opertion">
                  <i
                    class="iconfont icon-shanchu"
                    @click="deleteClueTasks(item)"
                  ></i>
                </div>
              </div>
            </div>
            <i
              v-show="
                tableParams.searchImageSelectData !== '3' &&
                tableParams.searchImageSelectData !== '4' &&
                tableParams.image
              "
              class="iconfont icon-jiantou_shangxiaqiehuan_o"
              @click="orderRuleClick"
            ></i>
            <span
              v-show="
                tableParams.searchImageSelectData !== '3' &&
                tableParams.searchImageSelectData !== '4' &&
                tableParams.image
              "
              :class="{ activeColor: tableParams.orderType == '0' }"
              @click="similarClick"
              >相似度
            </span>
            <i
              class="iconfont icon-jiantou_shangxiaqiehuan_o"
              @click="orderRuleClick"
            ></i>
            <span
              :class="{ activeColor: tableParams.orderType == '2' }"
              @click="timeClick"
              >时间</span
            >
            <i
              class="iconfont icon-guanbi2"
              style="color: red; cursor: pointer"
              @click="close"
            ></i>
          </div>
        </div>
        <div class="content">
          <h-icon
            v-show="!showOpenBtn"
            class="overPage"
            icon="icon-shangyi"
            rotate="-90"
            @click="overPage"
            font-size="24"
          ></h-icon>
          <div class="content_img">
            <template
              v-for="(item, index) in showOpenBtn ? searchDataList : pageList"
              :key="index"
            >
              <trackQueryImg
                v-model:slotList="slotList"
                :itemData="item"
                :searchList="searchDataList"
                @slot="addSlot"
                @getPosition="getPosition"
              ></trackQueryImg>
            </template>
          </div>
          <h-icon
            v-show="!showOpenBtn"
            class="nextPage"
            rotate="-90"
            icon="icon-xiayi"
            @click="nextPage"
            font-size="24"
          ></h-icon>
        </div>
        <div class="bottm">
          <el-pagination
            v-show="showOpenBtn"
            v-model:currentPage="currentPage"
            v-model:page-size="pageSize"
            :page-sizes="[100]"
            background
            layout="total, prev, pager, next"
            :total="searchDataListTotal"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
          <div
            class="closeBtn"
            :style="{
              transform: showOpenBtn ? 'rotate(-90deg)' : 'rotate(90deg)',
            }"
            @click="clickOpen"
          ></div>
        </div>
      </div>
      <h-big-picture
        v-if="bigPictureVisible"
        :pictureUrl="pictureUrl"
        v-model:visible="bigPictureVisible"
      ></h-big-picture>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  nextTick,
  onMounted,
} from "vue";
import util from "@util/js";
import _ from "lodash";
import { ElMessage } from "element-plus";
import trackQueryImg from "./trackQueryImg.vue";
import { url2ToBase } from "@/api/smartApplication/personSearchApi.js";
import {
  getSnapRetrievalFace,
  getSnapRetrievalPerson,
  getSnapRetrievalVehicle,
  getSnapRetrievalNonVehicle,
  pathList,
  savePathList,
  deletePathList,
} from "@/api/smartApplication/smartApplicationApi.js";

export default defineComponent({
  name: "searchPerson",
  components: { trackQueryImg },
  props: {
    searchParams: {
      type: Object,
      default: () => {},
    },
    trackMapRef: {
      type: Object,
      default: () => {},
    },
    queryFeature: {
      type: Object,
      default: "0",
    },
  },
  emits: [
    "closeSearchPerson",
    "handleMapLineNode",
    "handleMapLineNode",
    "startMapLine",
    "getPositionSearch",
  ],
  setup(props, context) {
    const data = reactive({
      loading: false,
      formVisible: false,
      showTrackList: false, //轨迹列表
      slotDisabled: false, //能否点击播放
      showOpenBtn: true,
      showCloseBtn: true,
      tableParams: {
        pageNum: 1,
        // orderType: "0", //排序类型 0：按相似度排序，2:按时间排序,
        // orderRule: "desc", //排序 desc 降序 asc 升序
      },
      searchList: [
        { name: "人脸", value: "1" },
        { name: "人体", value: "2" },
        { name: "机动车", value: "3" },
        { name: "非机动车", value: "4" },
      ],
      searchDataList: [],
      searchDataListTotal: 0,
      pictureUrl: null,
      bigPictureVisible: false,
      slotList: [],
      queryType: [],
      pageList: [],
      indexList: 0,
      lineMarkerObj: null,
      pageSize: 100,
      currentPage: 1,
      orderStatus: true,
      base64Str: "data:image/png;base64,",
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.tableParams = props.searchParams;
      data.queryType = props.queryFeature;
      if (!data.tableParams.image) {
        data.tableParams.orderType = "2";
      } else {
        data.tableParams.orderType = "0";
      }
    });
    const clickOpen = () => {
      data.showOpenBtn = !data.showOpenBtn;
      changeUserList();
      const searchDom = document.querySelector(".searchPerson");
      if (!data.showOpenBtn) {
        searchDom.style.height = "37%";
      } else {
        searchDom.style.height = "98%";
      }
    };
    const clickClose = () => {
      data.showCloseBtn = !data.showCloseBtn;
      const searchDom = document.querySelector(".searchPerson");
      if (!data.showCloseBtn) {
        searchDom.style.height = "0";
      } else {
        if (data.showOpenBtn) {
          searchDom.style.height = "98%";
        } else {
          searchDom.style.height = "37%";
        }
      }
    };
    const close = () => {
      context.emit("closeSearchPerson");
    };
    // 向左翻页
    const overPage = () => {
      data.indexList--;
      if (data.indexList < 0) {
        data.indexList = 1;
        ElMessage.warning("已到第一页");
        return;
      }
      data.showList = [];
      nextTick(() => {
        changeUserList();
      });
    };
    // 向右翻页
    const nextPage = () => {
      data.indexList++;
      if (data.indexList > parseInt(data.searchDataList.length / 9)) {
        data.indexList = parseInt(data.searchDataList.length / 9);
        ElMessage.warning("已到最后一页");
        return;
      }
      data.pageList = [];
      nextTick(() => {
        changeUserList();
      });
    };
    const changeUserList = () => {
      if (data.searchDataList.length == 0) return;
      let list = _.cloneDeep(data.searchDataList);
      if (data.indexList == parseInt(list / 9)) {
        data.pageList = list.filter((item, index) => {
          return (
            index > parseInt(data.searchDataList.length / 9) * 9 - 1 &&
            index <= data.searchDataList.length - 1
          );
        });
      } else {
        data.pageList = list.filter((item, index) => {
          return (
            index >= data.indexList * 9 && index < (data.indexList + 1) * 9
          );
        });
      }
    };
    // 点击查询按钮
    const refreshTable = () => {
      getSnapRetrievalFaceAsync();
    };
    // 点击相似度排序
    const similarClick = () => {
      data.tableParams.orderType = "0";
      data.tableParams.orderRule = "desc";
      data.orderStatus = true;
      getSnapRetrievalFaceAsync();
    };
    // 点击时间
    const timeClick = () => {
      data.tableParams.orderType = "2";
      data.tableParams.orderRule = "desc";
      data.orderStatus = true;
      getSnapRetrievalFaceAsync();
    };
    // 点击排序
    const orderRuleClick = () => {
      data.orderStatus = !data.orderStatus;
      if (data.orderStatus) {
        data.tableParams.orderRule = "desc";
        getSnapRetrievalFaceAsync();
      } else {
        data.tableParams.orderRule = "asc";
        getSnapRetrievalFaceAsync();
      }
    };
    //人脸+机动车+非机动车接口
    const getSnapRetrievalFaceAsync = async () => {
      console.log(data.tableParams, 111111111);
      let res, type;
      if (data.tableParams.imageList.length > 0) {
        type = data.tableParams.imageList[0].value;
      } else {
        type = data.tableParams.searchImageSelectData;
      }
      console.log(data.tableParams);
      //0,1走人脸 2走人体  3走机动车 4,走非机动车接口
      if (type == "0" || type == "1") {
        res = await getSnapRetrievalFace(data.tableParams, {
          loading: true,
          loadingDom: ".content",
        });
      } else if (type == "2") {
        res = await getSnapRetrievalPerson(data.tableParams, {
          loading: true,
          loadingDom: ".content",
        });
      } else if (type == "3") {
        res = await getSnapRetrievalVehicle(data.tableParams, {
          loading: true,
          loadingDom: ".content",
        });
      } else if (type == "4") {
        res = await getSnapRetrievalNonVehicle(data.tableParams, {
          loading: true,
          loadingDom: ".content",
        });
      }
      if (res && res.code == 0) {
        data.searchDataList = res.page.list;
        data.searchDataListTotal = res.page.totalCount;
        data.currentPage = res.page.currentPage;
        if (!data.showOpenBtn) {
          changeUserList();
        }
      }
    };

    // 播放路径
    const playLine = () => {
      data.slotDisabled = true;
      context.emit("startMapLine", data.slotList);
    };
    // 播放路径中点位数据
    const clearPlayLine = () => {
      let recordIds = data.slotList.map((item) => {
        return item.recordId;
      });
      console.log(recordIds);
      personDelSlot(recordIds);
    };

    // 改变页数
    const handleCurrentChange = (val) => {
      data.tableParams.pageNum = val;
      getSnapRetrievalFaceAsync();
    };
    const bigPicture = (url) => {
      state.pictureUrl = url;
      state.bigPictureVisible = true;
    };

    //地图定位
    const getPosition = (itemData) => {
      context.emit("getPositionSearch", itemData);
    };
    //添加点位到轨迹列表
    const addSlot = (itemData) => {
      let arr = data.slotList.find((element) => {
        if (element.recordId == itemData.recordId) {
          return element;
        }
      });
      if (arr) {
        personDelSlot([arr.recordId]);
      } else {
        data.slotList.push(itemData);
        personAddSlot(itemData);
      }
    };
    //删除路径列表中选中点位
    const deleteClueTasks = async (item) => {
      // data.slotList = data.slotList.filter((el) => {
      //   if (el.resultId !== item.resultId) {
      //     return el;
      //   }
      // });
      personDelSlot([item.recordId]);
    };
    //打开关闭列表
    const personSlot = async () => {
      data.showTrackList = !data.showTrackList;
    };
    //获取轨迹列表数据
    const getPersonSlot = async () => {
      let params = {
        isPage: false,
      };
      const res = await pathList(params);
      if (res.code == 0) {
        data.slotList = res.page.list;
      }
    };
    //添加数据到轨迹列表
    const personAddSlot = async (itemData) => {
      let obj = {
        recordId: itemData.recordId,
        sourceId: itemData.sourceId,
        sourceName: itemData.sourceName,
        online: itemData.online,
        fullUrl: itemData.fullUrl,
        partUrl: itemData.partUrl,
        passTime: itemData.passTime,
        longitude: itemData.longitude,
        latitude: itemData.latitude,
        similarityDegree: itemData.similarityDegree,
      };
      const res = await savePathList(obj);
      if (res.code == 0) {
        ElMessage.success("添加成功");
        // getPersonSlot();
      }
    };
    //删除轨迹列表数据
    const personDelSlot = async (recordId) => {
      let params = {
        ids: recordId,
      };
      const res = await deletePathList(params);
      if (res.code == 0) {
        ElMessage.success("移除成功");
        getPersonSlot();
      }
    };

    onMounted(async () => {
      await getPersonSlot();
      // refreshTable();
    });
    return {
      ...refData,
      clickOpen,
      clickClose,
      close,
      overPage,
      nextPage,
      refreshTable,
      bigPicture,
      addSlot,
      playLine,
      clearPlayLine,
      personSlot,
      getPosition,
      deleteClueTasks,
      handleCurrentChange,
      timeClick,
      similarClick,
      orderRuleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.searchPerson {
  position: absolute;
  z-index: 3;
  right: 0;
  top: 1%;
  width: calc(100% - 400px);
  height: 100%;
  .openBtn {
    position: absolute;
    top: -10px;
    left: 40%;
    width: 47px;
    height: 60px;
    z-index: 1;
    transform: rotate(90deg);
    background: url("~@/assets/images/home/icon.png") no-repeat;
    background-size: 100% 100%;
  }
  .search_person {
    position: relative;
    width: 100%;
    height: 100%;
    // min-height: 300px;
    overflow: hidden;
    background-image: url("~@/assets/images/home/bg.png");
    background-size: 100% 100%;
    .searchPersonContent {
      height: 100%;
      width: 100%;
      position: relative;
    }

    .header {
      padding: 16px;
      height: 60px;
      @include flex-row-sb-c;
      .el-select {
        margin-right: 12px;
      }
      span {
        color: #fff;
        margin: 0 16px 0 6px;
        cursor: pointer;
      }
      .activeColor {
        color: aqua;
      }
      i {
        color: aqua;
        cursor: pointer;
      }

      .slot-list {
        position: absolute;
        top: 45px;
        right: 50px;
        width: 250px;
        border: 1px solid #03e7e9;
        z-index: 10;
        background-color: rgba($color: #476287, $alpha: 0.9);
        margin: 12px 0;
        padding: 12px 8px;
        overflow: auto;
        .slot-list-btn {
          @include flex-row-sb-c;
        }
        .slot-list-item {
          height: 34px;
          @include flex-row-sb-c;
          .slot-name {
            color: #03e7e9;
            font-size: 14px;
            text-decoration: underline;
            cursor: pointer;
          }
          .slot-opertion {
            letter-spacing: 5px;
            cursor: pointer;
          }
        }
      }
    }
    .content {
      position: relative;
      height: calc(100% - 120px);
      .overPage {
        position: absolute;
        left: 5px;
        color: #1d92df;
        top: 60px;
        cursor: pointer;
      }
      .content_img {
        padding: 0 15px;
        height: 100%;
        overflow: auto;
        // display: grid;
        // grid-template-columns: repeat(auto-fill, 152px);
        // grid-template-rows: repeat(auto-fill, 190px);
        // grid-gap: 0px 5px;
        // justify-content: center;
        @include flex-row-sb-s;
        flex-wrap: wrap;
        .trackImg:last-child {
          margin-right: auto;
        }
      }
      .nextPage {
        position: absolute;
        right: 5px;
        color: #1d92df;
        top: 60px;
        cursor: pointer;
      }
    }
    .bottm {
      margin-top: 12px;
      /deep/.el-pagination__total {
        color: #fff;
      }
      .closeBtn {
        position: absolute;
        bottom: -16px;
        left: 41%;
        width: 40px;
        height: 50px;
        transform: rotate(-90deg);
        background: url("~@/assets/images/home/icon.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
